import { ExternalLink, Package, Plane, Star } from 'lucide-react';
import { cn } from '@tcrd/ui';
import { flightLink, needLabel } from '../lib/needs';

/** Distintivos del cliente para el conductor: vinculado (su enlace), frecuente y su puntuación. */
export function CustomerBadges({ c, className }: { c: { linked?: boolean; frequent?: boolean; rating?: string; ratingCount?: number; tripsWithYou?: number }; className?: string }) {
  const rating = Number(c.rating ?? 0);
  return (
    <span className={cn('flex flex-wrap items-center gap-1.5', className)}>
      {c.linked && <span className="rounded-full bg-green-600 text-white px-2.5 py-0.5 text-xs font-semibold">✓ Cliente vinculado</span>}
      {c.frequent && <span className="rounded-full bg-blue-100 text-blue-800 dark:bg-blue-500/20 dark:text-blue-200 px-2.5 py-0.5 text-xs font-semibold">Cliente frecuente</span>}
      <span className="text-xs flex items-center gap-1 text-[var(--text-muted)]">
        <Star className="size-3.5 fill-current text-amber-500" aria-hidden />
        <strong className="text-[var(--text)]">{rating > 0 ? rating.toFixed(1) : 'Nuevo'}</strong>
        {c.tripsWithYou ? `(${c.tripsWithYou} viaje${c.tripsWithYou === 1 ? '' : 's'} contigo)` : ''}
      </span>
    </span>
  );
}

/** Necesidades especiales, vuelo y envío de un viaje o solicitud. */
export function TripNeeds({ needs, flightNumber, pkg }: { needs?: string[]; flightNumber?: string | null; pkg?: { description: string; recipientName: string | null; recipientPhone: string | null } | null }) {
  if (!needs?.length && !flightNumber && !pkg) return null;
  return (
    <div className="flex flex-col gap-2">
      {!!needs?.length && (
        <div className="flex flex-wrap gap-1.5">
          {needs.map((n) => {
            const x = needLabel(n);
            return (
              <span key={n} className="rounded-full border border-brand-red/40 bg-brand-red/5 px-2.5 py-1 text-xs font-medium">
                {x.emoji} {x.label}
              </span>
            );
          })}
        </div>
      )}
      {flightNumber && (
        <a href={flightLink(flightNumber)} target="_blank" rel="noopener noreferrer" className="tap self-start inline-flex items-center gap-1.5 rounded-full bg-[var(--surface-2)] px-3 py-1 text-sm font-medium">
          <Plane className="size-4" aria-hidden /> Vuelo {flightNumber} · ver estado <ExternalLink className="size-3.5" aria-hidden />
        </a>
      )}
      {pkg && (
        <div className="rounded-xl bg-[var(--surface-2)] p-3 text-sm flex gap-2">
          <Package className="size-5 shrink-0 text-brand-red" aria-hidden />
          <div>
            <p className="font-medium" data-no-translate>{pkg.description}</p>
            {pkg.recipientName && (
              <p className="text-[var(--text-muted)]">
                Entregar a {pkg.recipientName}
                {pkg.recipientPhone ? <> · <a className="underline" href={`tel:${pkg.recipientPhone}`}>{pkg.recipientPhone}</a></> : null}
              </p>
            )}
          </div>
        </div>
      )}
    </div>
  );
}
